export default __webpack_public_path__ + "1e5e13bf499d3edcde7c59339db3af99.png";